<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication">
<p class="ded">To my Children,</p>
<p class="ded1">Alexandra Maria and Demetrious Theodore,</p>
<p class="ded1">for whom my love knows no bounds</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?d3011938